/**
 * @french
 * Génère une fonction de mise à jour Zustand avec prise en charge de fonction updater (comme setState de React)
 *
 * @template T - Type complet du store
 * @template K - Clé du champ à modifier
 */
export function createFunctionalSetter<T, K extends keyof T>(
  get: () => T,
  set: (partial: Partial<T>) => void,
  key: K,
): (updater: T[K] | ((prev: T[K]) => T[K])) => void {
  return (updater) => {
    const current = get()[key];
    const next =
      typeof updater === 'function' ? (updater as (prev: T[K]) => T[K])(current) : updater;

    set({ [key]: next } as unknown as Partial<T>);
  };
}
